import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';
import { PricingActions } from './actions';
import {
  TAXES_REQUEST,
  TAXES_SUCCESS,
  TAXES_FAILURE,
} from '../../constants/pricing';
import { ITax } from '../../components/PaymentGateway/interfaces/taxes';

export type PricingInfoState = {
  requested: boolean;
  taxes: ITax[];
  isLoading: boolean;
  error: string | null;
};
export type PricingInfoActions = ActionType<typeof PricingActions>;

export const pricingInfoReducer = combineReducers<
  PricingInfoState,
  PricingInfoActions
>({
  requested: (state = false, action) => {
    switch (action.type) {
      case TAXES_REQUEST:
        return true;
      default:
        return state;
    }
  },
  taxes: (state = [], action) => {
    switch (action.type) {
      case TAXES_SUCCESS:
        return action.payload.countries_taxes;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case TAXES_REQUEST:
        return true;
      case TAXES_FAILURE:
      case TAXES_SUCCESS:
        return false;
      default:
        return state;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case TAXES_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
